import { Injectable } from '@angular/core';
import { CrudService } from 'collection';
import { GetEntityModel } from 'collection';
import { ItemModel, Item, Collection, CollectionModel } from 'collection';

@Injectable({
  providedIn: 'root'
})
export class ProjectDetailService {
  projectItem: ItemModel;
  updateProjectItem: ItemModel;
  getAssignedUsers: GetEntityModel;
  assignUserCollection: Collection;

  constructor(private _crud: CrudService) {
    this.projectItem = new Item({
      api: this._crud.createEntity({ name: 'project' }),
      params: {
        expand: 'client,project_location'
      }
    });

    this.updateProjectItem = new Item({
      api: this._crud.createEntity({ name: 'project/:id' })
    });

    const assignUserAPI = this._crud.createEntity({ name: 'project/:project_id/assign-user' });
    this.assignUserCollection = new Collection({
      api: assignUserAPI,
      params: {
        expand: 'full_name',
        role: 'worker,manager',
        per_page: 8 // Number of employee icons
      }
    });
  }
}
